import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPaymentLink, startPayment } from '@actions/billing';
import mova from 'mova';
import Button from "../../../components/inputs/Button/Button";
import currency from '@filters/currency';

const t = mova.ns('pages.Payment');

const PaymentForm = ({ amount, billing, startPayment, getPaymentLink, showAmount = true }) => {
  const { place, reservation, description, data } = billing || {};

  const handleSubmit = async () => {
    startPayment(billing.data.hash);
    const body = {
      reservationId: reservation.id,
      description,
      amount: amount,
      clientId: data.clientId,
      successUrl: window.location.href,
      failedUrl: window.location.href,
    }
    const link = await getPaymentLink(place.uri, body);
    window.location = link.data.paymentLink;
  };

  return (
    <div>
      {showAmount && <div className='payment__amount'>{currency(billing.amount)}</div>}
      <Button size='large' style={{ width: '100%' }} className='payment__submit' onClick={handleSubmit}>
        {t('pay')}
      </Button>
    </div>
  );
};

PaymentForm.propTypes = {
  amount: PropTypes.number.isRequired,
  billing: PropTypes.object,
  startPayment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  startPayment,
  getPaymentLink,
};

export default connect(null, mapDispatchToProps)(PaymentForm);
